import { render } from "./Main.vue?vue&type=template&id=06bf9d12"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "/home/sergio/Escritorio/VSCode/Rosepetal/0.5.x-sergio/rosepetal-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__